import { PlayerContext } from "app/PlayerContext";
import { useContext, useEffect } from "react";
var useTogglePlayer = function (pausePlayer) {
    var _a = useContext(PlayerContext), player = _a.player, autoPaused = _a.autoPaused, setAutoPaused = _a.setAutoPaused;
    useEffect(function () {
        var _a;
        var myChannelsPlayer = (_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-mychannels-is-player]");
        if (myChannelsPlayer && myChannelsPlayer.player) {
            if (pausePlayer && myChannelsPlayer.player.playing) {
                myChannelsPlayer.player.pause();
                setAutoPaused(true);
            }
            else if (autoPaused) {
                myChannelsPlayer.player.play();
                setAutoPaused(false);
            }
        }
    }, [pausePlayer]);
};
export default useTogglePlayer;
